import { useEffect } from 'react';
import { Box, Divider, MenuItem, Select, Typography } from '@mui/material';

// Lets the user pick which rates version to quote from for a single insurer, as an
// alternative to RatesSettings.js's page-wide accordion - used inline in both the
// Quotation page's per-insurer *_Rates.js cards and the Auto Quotation page's
// *_Compact_Rates_Dialog.js dialogs.
export default function RatesVersionSelect({ insurer, label, insurerRates = [], selectedRatesVersion, setSelectedRatesVersion, disabled = false, onChange, handleFetchAppConfig, onRatesVersionChanged }) {
    const rates = insurerRates.filter(rate => rate.insurer === `${insurer}_rates`);

    useEffect(() => {
        if (rates.length === 0) return;

        const hasValidSelection = rates.some(rate => rate.version === selectedRatesVersion?.[insurer]);
        if (hasValidSelection) return;

        const latest = rates.find(rate => rate.is_latest) || rates[0];
        setSelectedRatesVersion(prev => ({ ...prev, [insurer]: latest.version }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [insurerRates]);

    if (rates.length === 0) return null;

    return (
        <Box>
            <Divider sx={{ my: 2 }} />
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography sx={{ fontWeight: 600, fontSize: 12, mr: 1 }}>{label}</Typography>
                <Select
                    size="small"
                    sx={{ fontSize: 13, minWidth: 200, '& .MuiSelect-select': { py: 0.5 } }}
                    value={selectedRatesVersion?.[insurer] || ''}
                    disabled={disabled}
                    onChange={(e) => {
                        const version = e.target.value;

                        // Mutated in place (rather than a functional update) so that
                        // handleFetchAppConfig below - which closes over this same
                        // selectedRatesVersion object - sees the new version immediately,
                        // instead of the stale one from this render.
                        selectedRatesVersion[insurer] = version;
                        setSelectedRatesVersion({ ...selectedRatesVersion });

                        if (onChange) onChange(version);
                        if (handleFetchAppConfig) handleFetchAppConfig();
                        if (onRatesVersionChanged) onRatesVersionChanged(version);
                    }}
                >
                    {rates.map(rate => (
                        <MenuItem key={rate.id} value={rate.version}>
                            {rate.version} {rate.is_latest ? '(Latest)' : ''}
                        </MenuItem>
                    ))}
                </Select>
            </Box>
        </Box>
    );
}
